<template>
  <el-dialog
    v-drag
    :title="rowData.status === 0 ? '录入' : '详情'"
    :visible.sync="dialogVisible"
    width="1340px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    top="5vh"
  >
    <div class="content">
      <div v-if="!rowData.invoiceType" class="header">
        <div class="item">
          <span class="label">客户</span>
          <span class="value">{{ form.companyName }}</span>
        </div>
        <div class="item">
          <span class="label">柜号</span>
          <span class="value">{{ form.containerNumber }}</span>
        </div>
        <div class="item">
          <span class="label">提单号</span>
          <span class="value">{{ form.mblNo }}</span>
        </div>
        <div class="item">
          <span class="label">分单号</span>
          <span class="value">{{ form.blNo }}</span>
        </div>
        <div class="item">
          <span class="label">重量</span>
          <span class="value">{{ form.weightKgs }}</span>
        </div>
        <div class="item">
          <span class="label">材积</span>
          <span class="value">{{ form.weightCbm }}</span>
        </div>
        <!-- <div class="item">
          <span class="label">收件人所属</span>
          <span class="value">{{ isBelong }}</span>
        </div> -->
        <div class="item">
          <span class="label">ISF状态</span>
          <span class="value">{{ isfStatus }}</span>
        </div>
        <div class="item">
          <span class="label">柜型</span>
          <span class="value">{{ form.containertype }}</span>
        </div>
        <div class="item">
          <span class="label">清关方式</span>
          <span class="value">{{ form.clearenceTypeName }}</span>
        </div>
        <div class="item">
          <span class="label">派送类型</span>
          <span class="value">{{ form.pickUpTypeName }}</span>
        </div>
        <div class="item">
          <span class="label">目的港</span>
          <span class="value">{{ form.destinationHarborName }}</span>
        </div>
        <div class="item">
          <span class="label">进口商</span>
          <span class="value">
            {{ form.importerName }}
            <span class="tips" :class="!form.importerPermission ? 'tips-owner': 'tips-out'">
              {{ !form.importerPermission ? '内部' : '外部' }}
            </span>
          </span>
        </div>
        <!-- <div class="item" style="display: flex">
          <el-input-number
            ref="inputNumber"
            v-model="form.entry"
            :min="0"
            :max="100"
            style="width: 125px"
            @keyup.enter.native="newAdd"
            @focus="$refs.inputNumber.select()"
          ></el-input-number>
          <div
            class="btn"
            style="width: 60px; margin-left: 10px"
            type="primary"
            @click="newAdd"
          >增加</div>
        </div> -->
        <!-- <el-form ref="form" :model="form" label-position="top">
          <el-row :gutter="20">
            <el-col :span="4.8">
              <el-form-item label="客户">
                <el-input
                  v-model="form.companyName"
                  style="width: 244px"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item label="柜号">
                <el-input
                  v-model="form.containerNumber"
                  style="width: 244px"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item label="提单号">
                <el-input
                  v-model="form.blNo"
                  style="width: 244px"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2.4">
              <el-form-item label="重量">
                <el-input
                  v-model="form.weightKgs"
                  style="width: 112px"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2.4">
              <el-form-item label="材积">
                <el-input
                  v-model="form.weightCbm"
                  style="width: 112px"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item label="收件人所属">
                <el-input
                  v-model="isBelong"
                  style="width: 244px"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="2.4">
              <el-form-item label="ISF状态">
                <el-input
                  v-model="isfStatus"
                  style="width: 112px"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2.4">
              <el-form-item label="柜型">
                <el-input
                  v-model="form.containertype"
                  style="width: 112px"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item label="清关方式">
                <el-input
                  v-model="form.clearenceTypeName"
                  style="width: 244px"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item label="派送类型">
                <el-input
                  v-model="form.pickUpTypeName"
                  style="width: 244px"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item label="目的港">
                <el-input
                  v-model="form.destinationHarborName"
                  style="width: 244px"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item label="条目">
                <el-input-number
                  ref="inputNumber"
                  v-model="form.entry"
                  :min="0"
                  :max="100"
                  style="width: 159px"
                  @keyup.enter.native="newAdd"
                  @focus="$refs.inputNumber.select()"
                ></el-input-number>
                <el-button
                  style="width: 75px; margin-left: 10px"
                  type="primary"
                  @click="newAdd"
                >增加</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form> -->
      </div>
      <div class="data">
        <el-table
          ref="multipleTable"
          :data="tableData.columns"
          border
          width="100%"
          :height="height"
          :header-cell-style="headerStyle"
          :cell-style="cellStyle"
          @selection-change="selectionChange"
          @sort-change="sortChange"
        >
          <el-table-column
            v-if="status === 2"
            align="center"
            fixed="left"
            type="selection"
            :selectable="selectable"
            resizable
          ></el-table-column>
          <el-table-column
            v-for="(item, index) in tableData.fileds"
            :key="index"
            :align="item.align || 'center'"
            header-align="center"
            :show-overflow-tooltip="true"
            :prop="item.filed"
            :label="item.label"
            :width="item.width"
            :formatter="item.formatter"
            resizable
            :sortable="item.sortable"
          >
            <template slot="header">
              <template v-if="ifFiled(item.filed)">
                <span style="color: red">* </span>{{ item.label }}
              </template>
            </template>
            <template slot-scope="scope">
              <el-popover
                v-if="
                  scope.row.status !== 1 &&
                    item.filed !== 'feeNameId' &&
                    item.filed !== 'mblSendWayId'
                "
                popper-class="table-pop-input"
                :disabled="item.filed !== 'remark'"
                placement="bottom"
                width="180"
                :visible-arrow="false"
                trigger="click">
                <el-input
                  v-model="scope.row[item.filed]"
                  type="textarea"
                  :rows="5"
                  placeholder="请输入内容">
                </el-input>
                <el-input
                  :id="`${item.filed + scope.$index}`"
                  :ref="`${item.filed + scope.$index}`"
                  slot="reference"
                  v-model="scope.row[item.filed]"
                  placeholder="请输入"
                  style="width: 100%"
                  :disabled="item.disabled"
                  :oninput="item.keyup"
                  @change="onChang(scope.row)"
                  @keydown.enter.native="handleTab(item.filed, scope.$index + 1)"
                  @keydown.tab.native="handleTab(item.filed, scope.$index + 1)"
                  @keyup.native="arrow($event, item.filed, scope.$index)"
                  @focus="inputFocus(item.filed, scope.$index)"
                ></el-input>
              </el-popover>
              <el-select
                v-else-if="
                  scope.row.status !== 1 &&
                    (item.filed === 'feeNameId' || item.filed === 'mblSendWayId')
                "
                :id="`${item.filed + scope.$index}`"
                :ref="`${item.filed + scope.$index}`"
                v-model="scope.row[item.filed]"
                style="width: 100%"
                filterable
                clearable
                placeholder="请选择"
                :filter-method="
                  (e) =>
                    filterMethod(
                      e,
                      item.filed === 'feeNameId'
                        ? feeOptionsCopy
                        : mblOptionsCopy,
                      scope.row,
                      item.filed
                    )
                "
                @blur="onBlur(item.filed, scope.row, scope.row[item.filed])"
                @focus="onFocus(item.filed, scope.row, scope.row[item.filed])"
                @change="onChange(item.filed, scope.row, scope.row[item.filed])"
                @keyup="arrow($event, item.filed, scope.$index)"
                @visible-change="(e) => visibleChange(e, item.filed)"
              >
                <template
                  v-if="scope.row.isSendWay && item.filed === 'mblSendWayId'"
                >
                  <el-option
                    v-for="a in mblOptions"
                    :key="a.value"
                    :label="a.label"
                    :value="a.value"
                  ></el-option>
                </template>
                <template v-else-if="item.filed === 'feeNameId'">
                  <el-option
                    v-for="a in feeOptions"
                    :key="a.value"
                    :label="a.label"
                    :value="a.value"
                    :disabled="!a.isActived"
                  ></el-option>
                </template>
              </el-select>
              <p v-else>
                <template
                  v-if="
                    item.filed === 'unitPrice' ||
                      item.filed === 'totalAmount' ||
                      item.filed === 'payableUnitPrice' ||
                      item.filed === 'payableTotalAmount'
                  "
                >{{
                  scope.row[item.filed]
                }}</template
                >
                <template v-else-if="item.filed === 'feeNameId'">{{
                  scope.row[item.filed] | feeName(that)
                }}</template>
                <template v-else-if="item.filed === 'mblSendWayId'">{{
                  scope.row[item.filed] | sendWay(that)
                }}</template>
                <template v-else>{{ scope.row[item.filed] }}</template>
              </p>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="94"
            style="width: 100%"
          >
            <template slot-scope="scope">
              <div class="tab-bt">
                <el-button
                  v-if="scope.row.status === 1"
                  type="text"
                  size="small"
                  @click="hedgingRow(scope.row)"
                >
                  对冲
                </el-button>
                <template v-if="scope.row.status !== 1">
                  <img
                    src="@/assets/images/const/delete.png"
                    title="删除"
                    @click="deleteRow(scope.$index)"
                  />
                </template>
                <i v-if="scope.$index === tableData.columns.length - 1 && scope.row.status !== 1" style="font-size: 16px; color:#1258bc;margin-left: 10px" class="el-icon-circle-plus-outline" title="增加" @click="newAdd"></i>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div v-if="status === 2" class="data-footer">
          已选择 <span>{{ selectionItem.length }}</span> 项
        </div> -->
      </div>
    </div>
    <span slot="footer" class="footers">
      <div class="custom-total flex_c_c">
        <div>
          总条数：<span>{{ tableData.columns.length }}</span>
        </div>
        <div>
          应收合计：<span>{{ receivableTotalAmount.toFixed(2) }} USD</span>
        </div>
        <div>
          应付合计：<span>{{ payableTotalAmount.toFixed(2) }} {{ tableData.columns.find(a => a.payableCurrency)?.payableCurrency }}</span>
        </div>
        <div>
          利润：<span
          >{{ (receivableTotalAmount - payableTotalAmount).toFixed(2) }} USD</span
          >
        </div>
      </div>
      <div class="footer-btn">
        <!-- <div class="cancel flex_c_c" @click="cancel">取消</div> -->
        <span class="optDocument flex_c_c" @click="dialogVisible1 = true">
          <i class="el-icon-question"></i>操作说明
        </span>
        <div v-debounce-click="ok" class="ok flex_c_c">提交</div>
        <!-- <div v-if="isCheckStatus" v-debounce-click="check" class="ok flex_c_c">审核</div> -->
      </div>
    </span>
    <OptDocumentDialog
      :dialogVisible="dialogVisible1"
      type="Receivables"
      @ok="dialogVisible1 = false"
    ></OptDocumentDialog>
    <HedgingDialog
      :dialogVisible="dialogVisible2"
      :editData="editData"
      :feeOptions="feeOptionsCopy"
      :mblOptions="mblOptionsCopy"
      @cancel="dialogVisible2 = false"
      @ok="ok1"
    ></HedgingDialog>
  </el-dialog>
</template>
<script>
import OptDocumentDialog from './OptDocumentDialog'
import HedgingDialog from './HedgingDialog'
import {
  getReceivableDetail,
  updateReceivableDetail,
  reviewedReceivableDetails,
  GetFeeNameList
} from '@/api/fee'
import { getMBLSendWay } from '@/api/bill'
import { debounce } from '@/utils/common'
import { mapGetters } from 'vuex'
import config from '@/utils/config'
export default {
  components: {
    OptDocumentDialog,
    HedgingDialog
  },
  filters: {
    sendWay(id, _this) {
      if (id && _this.mblOptions.length > 0) {
        return _this.mblOptionsCopy.find((a) => +a.value === +id)?.label
      } else {
        return ''
      }
    },
    feeName(id, _this) {
      if (id && _this.feeOptionsCopy.length > 0) {
        return _this.feeOptionsCopy.find((a) => +a.value === +id)?.label
      } else {
        return ''
      }
    },
    currency(val, filed, row) {
      if (filed === 'unitPrice' || filed === 'totalAmount') {
        return `${val} ${row.currency}`
      } else if (
        filed === 'payableUnitPrice' ||
        filed === 'payableTotalAmount'
      ) {
        return row.payableCurrency ? `${val} ${row.payableCurrency}` : val
      }
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    status: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      config,
      that: this,
      tableData: {
        fileds: [
          // {
          //   filed: 'receivableNumber',
          //   label: '应收单号',
          //   width: '150',
          //   disabled: true
          // },
          {
            filed: 'feeNameId',
            label: '费用项',
            width: '220',
            sortable: true,
            align: 'left'
          },
          // {
         //   filed: 'mblSendWayId',
         //   label: '派送方式',
          //  width: '140',
          //  sortable: true
         // },
          {
            filed: 'statusName',
            label: '状态',
            width: '80',
            disabled: true,
            sortable: true
          },
          {
            filed: 'qty',
            label: '数量',
            width: '80',
            keyup: `value=value.replace(/[^0-9.]/g, '')`,
            sortable: true
          },
          {
            filed: 'unitPrice',
            label: '单价',
            width: '100',
            keyup: `value=value.replace(/[^-0-9.]/g, '')`,
            sortable: true
          },
          {
            filed: 'totalAmount',
            label: '金额',
            width: '100',
            disabled: true,
            sortable: true
          },
          // {
          //   filed: 'arUnitName',
          //   label: '应收单位',
          //   width: '100',
          //   disabled: true
          // },
          {
            filed: 'remark',
            label: '备注',
            width: '200'
          },
          {
            filed: 'payableQty',
            label: '应付数量',
            width: '80',
            disabled: true
          },
          {
            filed: 'payableUnitPrice',
            label: '应付单价',
            width: '100',
            disabled: true
          },
          // {
          //   filed: 'apUnitName',
          //   label: '应付单位',
          //   width: '100',
          //   disabled: true
          // },
          {
            filed: 'payableTotalAmount',
            label: '应付费用',
            width: '100',
            disabled: true
          },
          {
            filed: 'payableInvoiceNumber',
            label: '应付账单号',
            width: '140',
            disabled: true
          },
          {
            filed: 'payableRemark',
            label: '应付备注',
            width: '200',
            disabled: true
          },
          {
            filed: 'createdName',
            label: '录入人',
            width: '140',
            disabled: true,
            sortable: true
          },
          {
            filed: 'createdOn',
            label: '录入时间',
            width: '180',
            disabled: true,
            sortable: true
          },
          {
            filed: 'reviewName',
            label: '审核人',
            width: '140',
            disabled: true,
            sortable: true
          },
          {
            filed: 'reviewOn',
            label: '审核时间',
            width: '180',
            disabled: true,
            sortable: true
          }
        ],
        columns: []
      },
      form: {},
      // receivableTotalAmount: 0,
      payableTotalAmount: 0,
      mblOptions: [],
      mblOptionsCopy: [],
      feeOptions: [],
      feeOptionsCopy: [],
      addObj: {
        feeNameId: '',
        mblSendWayId: '',
        qty: '1',
        unitPrice: '',
        totalAmount: '',
        remark: '',
        isSendWay: false,
        check: false,
        apUnitName: '',
        arUnitName: ''
      },
      selectionItem: [],
      dialogVisible1: false,
      dialogVisible2: false,
      newAddFlag: false,
      isfStatus: '',
      editData: {},
      height: 0
    }
  },
  computed: {
    ...mapGetters(['addressBookOptions']),
    receivableTotalAmount() {
      return this.tableData.columns.reduce((prev, next) => {
        return (prev +=
          +next.qty * (next.unitPrice !== '-' && +next.unitPrice))
      }, 0)
    },
    isBelong() {
      const item = this.addressBookOptions[0]?.find(
        (a) => a.companyName === this.rowData.consigneeName
      )
      return item?.permission
    },
    isCheckStatus() {
      return this.tableData.columns.filter((a) => a.id && a.status === 0).length > 0
    }
  },
  watch: {
    async dialogVisible(val) {
      if (val) {
        await this.$store.dispatch('getAddressBookOptions', { type: -1 })
        this.tableData.columns = []
        !this.rowData.invoiceType && this.getMBLSendWay()
        this.rowData.invoiceType && this.getList()
        this.GetFeeNameList()
      }
    }
  },
  async mounted() {
    this.height = document.querySelector('body').offsetHeight - 431
  },
  methods: {
    ifFiled(v) {
      if (
        v === 'feeNameId' ||
        v === 'qty' ||
        v === 'unitPrice' ||
        v === 'totalAmount'
      ) {
        return true
      } else {
        return false
      }
    },
    async GetFeeNameList() {
      try {
        const res = await GetFeeNameList({ feeTypeCode: 'MBLF;QGF;QTYW' })
        if (res.success) {
          const feeOptions = res.data.map((item) => {
            return {
              ...item,
              label: `${item.code} - ${item.name}`,
              value: item.id
            }
          }).filter(a => {
            if (this.rowData.invoiceType) {
              return a.isActived && a.feeTypeCode === 'QTYW'
            } else {
               return a.isActived && a.feeTypeCode !== 'QTYW'
            }
          })
          this.feeOptions = feeOptions
          this.feeOptionsCopy = feeOptions
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 派送方式
    async getMBLSendWay() {
      try {
        const res = await getMBLSendWay({ mblId: this.rowData.mblId })
        if (res.success) {
          const mblOptions = res.data.map((item) => {
            return {
              label: `${item.typeName} ${item.code ? `- ${item.code}` : ''}`,
              value: item.id
            }
          })
          this.mblOptions = mblOptions
          this.mblOptionsCopy = mblOptions
          this.$nextTick(() => {
            this.getList()
            this.rowData.id &&
              (this.form = {
                ...this.rowData,
                entry: 0
              })
           })
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getList() {
      try {
        const result = await getReceivableDetail({ id: this.rowData.id })
        if (result.success) {
         // if (result.data.length === 0) {
          //  this.newAdd()
          // }
          this.tableData.columns = result.data.data.map((a) => {
            const isSendWay = this.feeOptionsCopy.find(
              (b) => b.value === +a.feeNameId
            )?.isSendWay
            return {
              ...a,
              feeNameId: +a.feeNameId,
              mblSendWayId: a.mblSendWayId ? a.mblSendWayId.toString() : null,
              check: !a.status,
              isSendWay: isSendWay || false
            }
          })
          this.status !== 2 &&
            this.status !== 3 &&
            this.tableData.columns.push({
              feeNameId: '',
              mblSendWayId: '',
              qty: '1',
              unitPrice: '',
              totalAmount: '',
              remark: '',
              isSendWay: false,
              check: false,
              apUnitName: '',
              arUnitName: ''
            })
          // this.receivableTotalAmount = result.data.receivableTotalAmount
          this.payableTotalAmount = result.data.payableTotalAmount
          this.isfStatus = result.data.isfStatus
          if (this.status === 2) {
            this.$nextTick(() => {
              this.tableData.columns
                .filter((a) => a.status === 0)
                .forEach((item) => {
                  this.$refs.multipleTable.toggleRowSelection(item, true)
                })
            })
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    headerStyle({ columnIndex }) {
      if (this.status !== 2) {
        if ((columnIndex !== 16 && columnIndex > 6) || columnIndex === 5) {
          return {
            background: '#D6F3E6',
            color: '#333333',
            fontWeight: '400'
          }
        } else {
          return {
            background: '#F7F7F7',
            fontWeight: '400',
            color: '#333333'
          }
        }
      } else {
        if ((columnIndex !== 17 && columnIndex > 7) || columnIndex === 6) {
          return {
            background: '#D6F3E6',
            color: '#333333',
            fontWeight: '400'
          }
        } else {
          return {
            background: '#F7F7F7',
            fontWeight: '400',
            color: '#333333'
          }
        }
      }
    },
    cellStyle({ columnIndex }) {
      if (this.status !== 2) {
        if ((columnIndex !== 16 && columnIndex > 6) || columnIndex === 5) {
          return {
            background: '#F4FCF9'
          }
        }
      } else {
        if ((columnIndex !== 17 && columnIndex > 7) || columnIndex === 6) {
          return {
            background: '#F4FCF9'
          }
        }
      }
    },
    // 自动计算金额
    onChang(row) {
      const { qty, unitPrice } = row
      qty &&
        unitPrice &&
        (row.totalAmount =
          (+qty.toString().replace(/[^0-9.]/g, '') *
          +unitPrice.toString().replace(/[^-0-9.]/g, '')).toFixed(2))
      if (!qty || !unitPrice) {
        row.totalAmount = 0
      }
    },
    selectable(row) {
      return row?.check
    },
    selectionChange(v) {
      this.selectionItem = v
    },
    // 换行
    handleTab(filed, index) {
      const length = this.tableData.columns.length
      this.newAddFlag = false
      if (filed === 'remark' && index === length) {
        this.tableData.columns.push({
          feeNameId: '',
          mblSendWayId: '',
          qty: '1',
          unitPrice: '',
          totalAmount: '',
          remark: '',
          check: false,
          apUnitName: '',
          arUnitName: ''
        })
      }
    },
    // 自定义下拉框搜索
    filterMethod: debounce(async function(e, array, item, filed) {
      if (e) {
        const value = e.toLowerCase()
        const arr = [...array].filter((a) =>
          a.label.toLowerCase().includes(value)
        );
        (await filed) === 'feeNameId' && (this.feeOptions = arr);
        (await filed) === 'mblSendWayId' && (this.mblOptions = arr)
        arr[0]?.value &&
          filed === 'feeNameId' &&
          (item.feeNameId = arr[0]?.value)
        arr[0]?.value &&
          filed === 'mblSendWayId' &&
          (item.mblSendWayId = arr[0]?.value)
      } else {
        this.feeOptions = this.feeOptionsCopy
        this.mblOptions = this.mblOptionsCopy
      }
    }, 400),
    // 获取焦点默认选中
    onFocus(filed, item) {
      if (filed === 'feeNameId') {
        if (item.feeNameId === 1055) {
          const weightKgs = (this.rowData.weightKgs * 2.2046).toFixed(2)
          const weightCbm = ((this.rowData.weightCbm / 167) * 2.2046).toFixed(
            2
          )
          weightKgs > weightCbm && (item.qty = Math.ceil(weightKgs))
          weightKgs < weightCbm && (item.qty = Math.ceil(weightCbm))
          weightKgs === weightCbm && (item.qty = Math.ceil(weightKgs))
        }
        if (item.feeNameId === 1056) {
          const weightCbm = this.rowData.weightCbm / 1.8
          item.qty = Math.ceil(weightCbm)
        }
        item.feeNameId !== 1055 && item.feeNameId !== 1056 && (item.qty = '')
        item.mblSendWayId = ''
        // !item.feeNameId && (item.feeNameId = this.feeOptions[0]?.value)
        // !item.isSendWay && (item.isSendWay = this.feeOptions[0]?.isSendWay)
      } else {
        item.isSendWay && (item.mblSendWayId = this.mblOptions[0]?.value)
      }
    },
    onBlur(filed, item, v) {
      if (filed === 'feeNameId') {
        const feeName = this.feeOptionsCopy.find(
          (a) => a.value === v
        )
        item.isSendWay = feeName?.isSendWay
        item.apUnitName = this.config.feeNameUnitTypeOptions.find(a => a.value === feeName.apUnit)?.label
        item.arUnitName = this.config.feeNameUnitTypeOptions.find(a => a.value === feeName.arUnit)?.label
      }
    },
    onChange(filed, item, v) {
      if (filed === 'feeNameId') {
        this.feeOptions = this.feeOptionsCopy
        const feeName = this.feeOptionsCopy.find(
          (a) => a.value === v
        )
        item.isSendWay = feeName?.isSendWay
        item.apUnitName = this.config.feeNameUnitTypeOptions.find(a => a.value === feeName.apUnit)?.label
        item.arUnitName = this.config.feeNameUnitTypeOptions.find(a => a.value === feeName.arUnit)?.label
        if (item.feeNameId === 1055) {
          const weightKgs = (this.rowData.weightKgs * 2.2046).toFixed(2)
          const weightCbm = ((this.rowData.weightCbm / 167) * 2.2046).toFixed(
            2
          )
          weightKgs > weightCbm && (item.qty = Math.ceil(weightKgs))
          weightKgs < weightCbm && (item.qty = Math.ceil(weightCbm))
          weightKgs === weightCbm && (item.qty = Math.ceil(weightKgs))
        }
        if (item.feeNameId === 1056) {
          const weightCbm = this.rowData.weightCbm / 1.8
          item.qty = Math.ceil(weightCbm)
        }
        item.feeNameId !== 1055 && item.feeNameId !== 1056 && (item.qty = '')
      } else {
        this.mblOptions = this.mblOptionsCopy
      }
    },
    visibleChange(e, filed) {
      if (e) {
        if (filed === 'feeNameId') {
          this.feeOptions = this.feeOptionsCopy
        } else {
          this.mblOptions = this.mblOptionsCopy
        }
      }
    },
    inputFocus(filed, index) {
      if (filed !== 'remark') {
        this.$refs[filed + index][0].select()
      }
    },
    // 键盘箭头事件
    arrow(e, filed, index) {
      const keyCode = e.keyCode
      // 当前dom元素id
      const id = filed + index
      // 光标长度
      const cursurPosition = document.getElementById(id).selectionStart
      // 文本长度
      const textLenght = document.getElementById(id).value.length
      // 数据数组
      const tableData = this.tableData.columns
      switch (keyCode) {
        case 37:
          if (cursurPosition === 0) {
            if (filed === 'qty') {
              document.getElementById(`mblSendWayId${index}`).focus()
              if (
                index !== tableData.length &&
                tableData[index].isSendWay &&
                !tableData[index].mblSendWayId
              ) {
                tableData[index].mblSendWayId = this.mblOptionsCopy[0].value
              } else if (
                index === tableData.length &&
                this.contrastObj.isSendWay &&
                !this.contrastObj.mblSendWayId
              ) {
                this.contrastObj.mblSendWayId = this.mblOptionsCopy[0].value
              }
            }
            filed === 'unitPrice' &&
              document.getElementById(`qty${index}`).focus()
            filed === 'remark' &&
              document.getElementById(`unitPrice${index}`).focus()
          }
          break
        case 39:
          if (cursurPosition === textLenght) {
            filed === 'qty' &&
              document.getElementById(`unitPrice${index}`).focus()
            filed === 'unitPrice' &&
              document.getElementById(`remark${index}`).focus()
          }
          break
        case 38:
          if (index) {
            // 筛选掉不可输入的行数据，同时从后面开始获取比当前下标小的
            const isCanInputIndex = tableData.findLastIndex(
              (a, i) => a.status !== 1 && i < index
            )
            filed === 'qty' &&
              document.getElementById(`qty${isCanInputIndex}`).focus()
            filed === 'unitPrice' &&
              document.getElementById(`unitPrice${isCanInputIndex}`).focus()
            filed === 'remark' &&
              (document.getElementById(`remark${isCanInputIndex}`).focus(),
                document.getElementById(`remark${isCanInputIndex}`).setSelectionRange(0, 0))
          }
          break
        case 40:
          if (index + 1 < tableData.length) {
            // 筛选掉不可输入的行数据，同时从前面开始获取比当前下标大的
            let isCanInputIndex = tableData.findIndex(
              (a, i) => a.status !== 1 && i > index
            )
            isCanInputIndex =
              isCanInputIndex === -1 ? tableData.length : isCanInputIndex
            filed === 'qty' &&
              document.getElementById(`qty${isCanInputIndex}`).focus()
            filed === 'unitPrice' &&
              document.getElementById(`unitPrice${isCanInputIndex}`).focus()
            filed === 'remark' &&
              (document.getElementById(`remark${isCanInputIndex}`).focus(),
                document.getElementById(`remark${isCanInputIndex}`).setSelectionRange(0, 0))
          }
          break
          case 13:
          filed === 'qty' &&
          document.getElementById(`unitPrice${index}`).focus()
            filed === 'unitPrice' &&
            document.getElementById(`remark${index}`).focus()
            break
      }
    },
    // 删除
    async deleteRow(index) {
      this.$refs.multipleTable.tableData.splice(index, 1)
      this.tableData.columns = [...this.$refs.multipleTable.tableData]
    },
    cancel() {
      this.tableData.columns = []
      this.$emit('cancel')
    },
    // 提交
    async ok() {
      try {
        const tableData = [...this.tableData.columns].filter(a => a.feeNameId)
        let flag1 = false
        let flag2 = false
        if (tableData.length > 0) {
          tableData.forEach((a, i) => {
            const { feeNameId, qty, unitPrice } = a
            if (
              i + 1 !== tableData.length &&
              (!feeNameId || !qty || +qty === 0 || unitPrice === '' || +unitPrice === 0)
            ) {
              flag1 = true
            }
            if (
              i + 1 === tableData.length &&
              !feeNameId &&
              !qty &&
              unitPrice === ''
            ) {
              flag2 = true
            }
          })
          flag2 && tableData.splice(tableData.length - 1, 1)
          // 更新
          if (flag1) {
            this.$message.warning(
              '费用项、数量、价格不能为空，且数量不能为0和价格不能为0'
            )
            return
          }
          if (!flag2) {
            const { feeNameId, qty, unitPrice } = tableData[tableData.length - 1]
            if (
              !feeNameId ||
              !qty ||
              unitPrice === '' ||
              +qty === 0 ||
              +unitPrice === 0
            ) {
              this.$message.warning(
                '费用项、数量、价格不能为空，且数量不能为0和价格不能为0'
              )
              return
            }
          }
        }
        const params = {
          data: tableData,
          invoiceId: this.rowData.id
        }
        const result = await updateReceivableDetail(params)
        if (result.success) {
          this.cancel()
          this.$emit('ok')
          this.$message.success(result.errorMessage)
        } else {
          this.$message.error(result.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 审核
    async check() {
      try {
        const ids = this.tableData.columns.filter((a) => a.id && a.status === 0).map(a => a.id)
        const isNoId = this.tableData.columns.filter((a) => !a.id)
        const tableData = [...this.tableData.columns]
        let flag1 = false
        let flag2 = false
        tableData.forEach((a, i) => {
          const { feeNameId, qty, unitPrice } = a
          if (
            i + 1 !== tableData.length &&
            (!feeNameId || !qty || +qty === 0 || unitPrice === '')
          ) {
            flag1 = true
          }
          if (
            i + 1 === tableData.length &&
            !feeNameId &&
            !qty &&
            unitPrice === ''
          ) {
            flag2 = true
          }
        })
        flag2 && tableData.splice(tableData.length - 1, 1)
        if (isNoId.length > 0) {
          this.$message.warning('提交后再审核')
          return
        }
          // 审核
          if (flag1) {
            this.$message.warning(
              '费用项、数量、价格不能为空，且数量价格不能为0'
            )
            return
          }
          if (!flag2) {
            const { feeNameId, qty, unitPrice } =
              tableData[tableData.length - 1]
            if (!feeNameId || !qty || +qty === 0 || unitPrice === '') {
              this.$message.warning('费用项、数量、价格不能为空')
              return
            }
          }
          const result = await reviewedReceivableDetails(ids)
          if (result.success) {
            this.cancel()
            this.$emit('ok')
            this.$message.success(result.errorMessage)
          } else {
            this.$message.error(result.errorMessage)
          }
      } catch (error) {
        console.error(error)
      }
    },
    newAdd() {
      // if (!this.form.entry) return
      // this.$refs.multipleTable.clearSort()
      // this.newAddFlag = true
      // let i = 0
      // while (i < this.form.entry) {
        this.tableData.columns.push({
          feeNameId: '',
          mblSendWayId: '',
          qty: '1',
          unitPrice: '',
          totalAmount: '',
          remark: '',
          isSendWay: false,
          check: false,
          apUnitName: '',
          arUnitName: ''
        })
       //  i++
      // }
    },
    hedgingRow(row) {
      this.editData = row
      this.dialogVisible2 = true
    },
    ok1(obj) {
      this.tableData.columns.push(obj)
      this.dialogVisible2 = false
    },
    sortChange() {
      const sortTableColumns = this.$refs.multipleTable.tableData
      this.tableData.columns = [...sortTableColumns]
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-dialog__header {
  border: 0;
}
/deep/ .el-dialog__body {
  padding-top: 0;
  padding-bottom: 20px;
}
/deep/ .el-dialog__footer {
  padding: 0 20px 20px 20px;
}
/deep/ .el-table--border .el-table__cell:first-child .cell {
  padding: 0;
  padding-left: 10px;
}
/deep/ .el-table tr th {
  height: 40px;
  padding: 0;
}
/deep/ .el-table tr td {
  height: 30px;
  padding: 0;
}
/deep/ .el-table tr td .cell {
  padding: 0;
  height: 30px;
  line-height: 30px;
}
.content {
  width: 100%;
  margin: 0 auto;
  .header {
    width: calc(100% - 48px);
    height: auto;
    padding: 20px 24px;
    display: flex;
    flex-wrap: wrap;
    background: #F7F7F7;
    border-radius: 6px 6px 6px 6px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    .item {
      width: 25%;
      .label {
          display: inline-block;
          width: 70px;
          height: 14px;
          color: #666666;
      }
      .value {
        display: inline-block;
        width: calc(100% - 90px);
        height: 14px;
        color: #333333;
        margin-left: 20px;
      }
      .tips {
        margin-left: 5px;
        display: inline-block;
        width: auto;
        height: 20px;
        padding: 0 10px;
        font-size: 12px;
        line-height: 20px;
      }
      .tips-owner {
        color: rgba(53, 186, 131, 1);
        background: rgba(53, 186, 131, .1);
      }
      .tips-out {
        color: rgba(254, 69, 61, 1);
        background: rgba(254, 69, 61, .1);
      }
      &:nth-child(n+ 5) {
        margin-top: 20px
      }
      .btn {
        width: 60px;
        height: 40px;
        background:  rgb(18,88,188);
        border-radius: 4px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .data {
    width: 100%;
    border-radius: 4px 4px 4px 4px;
    overflow: hidden;
    margin-top: 24px;
    .data-footer {
      margin-top: 20px;
      margin-left: 10px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      span {
        color:  rgb(18,88,188);
      }
    }
    :deep(.el-input__inner) {
      height: 30px;
      border: 0;
      padding: 0;
      text-align: center;
    }
    :deep(.el-input__inner[disabled="disabled"]) {
      text-align: center;
    }
    :deep(.el-input__suffix) {
      width: 30px;
      height: 30px;
      right: 0;
    }
    :deep(.el-input__suffix-inner) {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
    :deep(.el-select__caret) {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 14px;
      height: 14px;
      line-height: inherit;
    }
  }
  .tab-bt {
    display: flex;
    justify-content: space-around;
    align-items: center;
    img {
      cursor: pointer;
    }
  }
  .add {
    color:  rgb(18,88,188);
    cursor: pointer;
  }
}
.footers {
  display: flex;
  justify-content: space-between;
  .footer-btn {
    display: flex;
  }
  .custom-total {
    width: 660px;
    height: 40px;
    background: #f7f7f7;
    border-radius: 4px 4px 4px 4px;
    box-sizing: border-box;
    overflow: hidden;
    font-size: 13px;
    span {
      color: #fe453d;
      font-weight: bold;
    }
    div + div {
      margin-left: 20px;
    }
  }
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 100px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    margin-left: 10px;
  }
  .optDocument {
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #fe453d;
    cursor: pointer;
    margin-right: 10px;
  }
}
</style>
<style lang="less">
.table-pop-input {
  margin-top: -30px !important;
}
</style>
